/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureEaAccount extends models.ServiceAccountNativeDetailsBaseForStructure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureEaAccount");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureEaAccount.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureEaAccount>): ServiceAccountNativeDetailsForAzureEaAccount {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureEaAccount(), model);
        ServiceAccountNativeDetailsForAzureEaAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureEaAccount>): ServiceAccountNativeDetailsForAzureEaAccount {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureEaAccount.newInstance(<ServiceAccountNativeDetailsForAzureEaAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureEaAccount) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureEaAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureEaAccount): boolean {
        if (models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureEaAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Account Id
     */
    account_id: string;

    /**
     * Account Name
     */
    account_name: string;

}
